import { IonFabButton, IonFab, useIonViewDidEnter, IonChip, IonIcon, IonGrid, IonCol, IonRow, IonRefresherContent, IonRefresher, IonSearchbar, useIonViewWillEnter, useIonRouter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { eyeOutline, eyeOffOutline, heart } from 'ionicons/icons';
import React, { useState, useRef, useEffect }  from 'react';
import { RouteComponentProps } from "react-router-dom";
import { Virtuoso } from 'react-virtuoso';

import { showAlert } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { Device } from '@capacitor/device';
import { Browser } from '@capacitor/browser';
import NServer, { UIElement, handleRouteError } from "../components/NServer";
import { ContentInfo, CreateContentInfo, FilterUniqueContent, ReponsiveContentResize, ReponsiveContentItemResize } from "../data/item";
import ContentWrapper from "../components/ContentWrapper";
import { LANGUAGE, GetStr } from "../language/Language";
import { InitAdMobs, ReadyAds, ShowAds } from "../components/Admob";
import NoMoreContent from "../components/NoMoreContent";

import '../pages/Main.css'; 

var index = 0;
const total = 4;
var noMoreLoadData = false;
var loading = false;
var category = 0;

const Explore : React.FC = () => {

    const [searchText, setSearchText] = useState('');
    const [contents, setContents] = useState<ContentInfo[]>([]);
    const [streams, setStreams] = useState<ContentInfo[]>([]);
    const [canRefresh, setCanRefresh] = useState(true);
    const [endOfContent, setEndOfContent] = useState(false);
    const [tokens, setTokens] = useState(0);
    const [viewAll, setViewAll] = useState(false);
    const [categoryIndex, setCategoryIndex] = useState(0);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewDidEnter(() => {
        // check window scroll position
        var doc = document.getElementById("explore-con-view");
        var top = 0;
        if (doc != null)
            top = doc.scrollTop;

        // refresh
        if (index == 0 || top < 1)
            doRefresh(null);

        // load again in case first time is not loaded
        setTimeout( () => {
            let e = document.getElementById('nc-content');
            if (e == null && !loading)
                doRefresh(null);
        }, 1000);

        InitAdMobs();
    });

    // when search text is changed
    useEffect(() => {
        // filter here
        let query = searchText.toLowerCase();
        if (query == "")
        {
            noMoreLoadData = false;
            setContents(getDefContents().concat(streams));
        }
        else
        {
            noMoreLoadData = true;

            setContents(streams.filter(d => (d.user_name.toLowerCase().indexOf(query) > -1) || 
                (d.desc.toLowerCase().indexOf(query) > -1) ||
                (d.title.toLowerCase().indexOf(query) > -1)));
        }
    }, [searchText]);

    // update when view changed
    useEffect(() => {
        console.log("Update");
        doRefresh(null);
    }, [viewAll]);

    // load new page
    const loadNewPage = () => {

    }

    const loadMoreData = async () => {
        if (noMoreLoadData || loading)
            return;

        await getData();
    }

    const getData = async () => {
        let v = new Vault();
        await v.read();

        let category_index = category;

        const state = {
            id: v.account.id,
            pass: v.account.key,
            category: category,
            view_all: viewAll ? 1 : 0,
            s: index,
            e: total
        }

        loading = true;

        var server = new NServer();
        await server.getList("nc_explore", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            const d = server.data;

            if (d != null)
            {
                if (category == server.data.category)
                {
                    setTokens(server.data.token);

                    var dataStream = null;
                    if (server.data.stream != null)
                    {
                        if (index == 0)
                            dataStream = server.data.stream;
                        else
                            dataStream = streams.concat(server.data.stream);

                        // filter
                        dataStream = FilterUniqueContent(dataStream);
                        // responsive resize
                        dataStream = ReponsiveContentResize("explore-con-view", dataStream);

		                setStreams(dataStream);
                    }
                
                    // if we reach end of data
                    noMoreLoadData = server.data.nomore == "yes";
                    index = server.data.index;

                    let contentStream = getDefContents().concat(dataStream);
                
                    setContents(contentStream);

                    setEndOfContent(noMoreLoadData);
                }
            }
        }

        loading = false;
    }

    // get the default content type array
    const getDefContents = () : ContentInfo[] => {
        
        let threads = [
            CreateContentInfo(category, "categories", "", "")
        ];
        return threads;
    }

    // just update specific content
    const getContentData = async (index: number, id : number) => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: id,
            view_all: viewAll ? 1 : 0
        }

        var server = new NServer();
        await server.getList("nc_content", state);
        if (server.success)
        {
            if (server.data.tokens != null)
                setTokens(server.data.tokens);

            let contentData : ContentInfo = server.data.content;
            contentData = ReponsiveContentItemResize("explore-con-view", contentData);

            let defStream = getDefContents();
            streams[index-defStream.length] = contentData;
            
            // need to copy stream to update
            let streamCopy = streams.slice();
            setStreams(streamCopy);
            setContents(defStream.concat(streamCopy));
        }
    }

    // update a content
    const onUpdateContent = (index : number, content : ContentInfo, local : boolean) => {
        // for category control trigger
        if (content.type == "categories" || content.type == "explore_empty")
        {
            categoryUpdate(index);
            return;
        }
        
        if (local)
        {
            // local update
            let defStream = getDefContents();
            streams[index-defStream.length] = content;
            
            // need to copy stream to update
            let streamCopy = streams.slice();
            setStreams(streamCopy);
            setContents(defStream.concat(streamCopy));
        }
        else
            getContentData(index, content.id);
    }

    const doSearch = async (term : string) => {
        index = 0;
    }

    // scroll event
    const onScrollTop = (val : boolean) => {
        setCanRefresh(val);
    }

    // refresh event
    const doRefresh = async (ev : any) => {
        index = 0;
        noMoreLoadData = false;
        loading = false;

        await getData();

        if (ev != null)
            ev.detail.complete();
    };

    // update the category update
    const categoryUpdate = (cat : number) => {
        index = 0;
        noMoreLoadData = false;
        loading = false;
        category = cat;
        setCategoryIndex(cat);
        setViewAll(false);
        
        // clear
        setContents(getDefContents());
        setStreams([]);
        getData();
    }

    // click on love icon
    const onLike = () => {
        router.push("/token/wallet", "forward", "push");
    }

    // change the view mode
    const changeViewMode = () => {
        setViewAll(!viewAll);
    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar className="content-wrapper">
                    <IonSearchbar className="search-bubble" slot="start" placeholder={ GetStr(LANGUAGE.TXT_SEARCH) } value={searchText} onIonChange={e => setSearchText(e.detail.value!)}></IonSearchbar>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen scrollY={false}>
                <IonRefresher className="refresher" slot="fixed" disabled={!canRefresh} onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonGrid className="ion-no-padding full-screen">
                    <IonRow className="full-screen">
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="5" size-sm="10" size="12">
                            <Virtuoso id="explore-con-view" className="main-content ion-content-scroll-host"
                                atTopStateChange={onScrollTop}
                                defaultItemHeight={350}
                                data={contents}
                                totalCount={contents.length}
                                endReached={loadMoreData}
                                components={{
                                    Footer: () => {
                                        return (
                                            <NoMoreContent nomore={endOfContent} />
                                        )
                                    },
                                }}
                                itemContent={(index, content) => 
                                    <ContentWrapper key={content.id} content={content} index={index} onUpdate={onUpdateContent} view="def" autoplay={false} />
                                }
                            >
                            </Virtuoso>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                {
                    // only show in 18 plus category
                    categoryIndex == 4 ?
                <IonFab vertical="bottom" horizontal="end" slot="fixed">
                    <IonFabButton onClick={changeViewMode}><IonIcon icon={ viewAll ? eyeOffOutline : eyeOutline } /></IonFabButton>
                </IonFab>
                    :
                <div/>
                }
            </IonContent>
        </IonPage>
    );
};

export default Explore;